(function () {
  'use strict';

  const SELECTOR_ACCORDION = '[data-mm-accordion]';
  const SELECTOR_ITEM = '[data-mm-accordion-item]';
  const SELECTOR_TRIGGER = '[data-mm-accordion-trigger]';
  const SELECTOR_PANEL = '[data-mm-accordion-panel]';
  const CLASS_OPEN = 'mm-accordion__item--open';

  function openItem(item) {
    const trigger = item.querySelector(SELECTOR_TRIGGER);
    const panel = item.querySelector(SELECTOR_PANEL);

    if (!trigger || !panel) return;

    item.classList.add(CLASS_OPEN);
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function closeItem(item) {
    const trigger = item.querySelector(SELECTOR_TRIGGER);
    const panel = item.querySelector(SELECTOR_PANEL);

    if (!trigger || !panel) return;

    item.classList.remove(CLASS_OPEN);
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function initAccordion(accordion) {
    if (!accordion || accordion.dataset.mmAccordionInit === 'true') return;
    accordion.dataset.mmAccordionInit = 'true';

    const items = Array.from(accordion.querySelectorAll(SELECTOR_ITEM));

    items.forEach((item) => {
      const trigger = item.querySelector(SELECTOR_TRIGGER);
      const panel = item.querySelector(SELECTOR_PANEL);

      if (!trigger || !panel) return;

      const shouldBeOpen =
        item.classList.contains(CLASS_OPEN) ||
        trigger.getAttribute('aria-expanded') === 'true';

      if (shouldBeOpen) {
        openItem(item);
      } else {
        closeItem(item);
      }

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains(CLASS_OPEN);

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function init(root) {
    const scope = root || document;
    const accordions = scope.querySelectorAll(SELECTOR_ACCORDION);
    accordions.forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.MmAccordion = { init: init };

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();